<template>
	<div class="companyDetail-container">
		<div class="companyDetail-content">
			<!-- vip滚动区域--start -->
			<div class="vip-container">
				<div class="vip-content">
					<div class="vip-swiper">
						<ul class="swiper-wrapper">
							<li v-for="(item, index) in vipMessages" :key="index" class="swiper-slide">
								<img src="@/assets/qualificationQuery/vip_icon.png" alt="" />
								<p>{{ item.message }}</p>
								<el-button @click="payVisible = true">立即开通</el-button>
							</li>
						</ul>
					</div>
					<div class="export-content">
						<span @click="handleExportCompanyReport">
							<svg-icon icon-class="export" class="icon" />
							导出报告
						</span>
						<span
							:class="{ activeCollect: companyDetail.isCollect }"
							@click="handleIsCollect(companyDetail.id, companyDetail.isCollect)"
						>
							<svg-icon v-if="companyDetail.isCollect" icon-class="collected" class="icon" />
							<svg-icon v-else icon-class="collect" class="icon" />
							{{ companyDetail.isCollect ? '已收藏' : '收藏' }}
						</span>
						<span
							:class="{ activeMonitor: companyDetail.isMonitoring }"
							@click="handleIsMonitoring(companyDetail.id, companyDetail.isMonitoring)"
						>
							<svg-icon v-if="companyDetail.isMonitoring" icon-class="monitored" class="icon" />
							<svg-icon v-else icon-class="monitor" class="icon" />
							{{ companyDetail.isMonitoring ? '已监控' : '监控' }}
						</span>
					</div>
				</div>
			</div>
			<!-- vip滚动区域--end -->
			<!-- 人员信息--start -->
			<div class="information-container">
				<div class="information-content">
					<div class="basic-content">
						<div class="tab-container">
							<div class="cjt-tabs">
								<div class="section-sub-title">
									<h4>企业详情</h4>
								</div>
								<div class="cjt-tabs__content" v-loading="loading">
									<div class="basic-info">
										<h4 class="name">
											{{ companyDetail.companyName }}
											<span class="on-job">
												{{ companyDetail.companyType }}
											</span>
										</h4>
										<p>
											<span>湖北省内办公地址：{{ companyDetail.registeredAddress }}</span>
										</p>
										<p>
											<span>统一社会信用代码：{{ companyDetail.companyCode }}</span>
										</p>
										<p>
											<span>法人代表：{{ companyDetail.legalPerson }}</span>
											<span>法人职务：{{ companyDetail.legalPersonJob }}</span>
											<span>进鄂负责人姓名：{{ companyDetail.contacts }}</span>
										</p>
										<p>
											<span>行政区：{{ companyDetail.zoning }}</span>
											<span>成立时间：{{ companyDetail.registeredTime }}</span>
											<span>注册资本金（万元）：{{ companyDetail.registeredCapital }}</span>
										</p>
										<p>
											<span>营业执照工商登记注册类型：{{ companyDetail.registeredTypeName }}</span>
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="people-content">
						<div class="vip-title">
							企业画像
							<span class="tag-member-mini tag-member--vip">VIP</span>
						</div>
						<div v-loading="portraitLoading" class="people-echarts">
							<radar-chart
								ref="radarChart"
								:chart-data="portraitData"
								:indicator="portraitIndicator"
								title="能力评估雷达图"
								height="230px"
							/>
						</div>
						<!-- 未开通会员提示 -->
						<nonbind-vip v-if="isNormalVip" className="small-mask-content"></nonbind-vip>
					</div>
				</div>
			</div>
			<!-- 人员信息--end -->

			<!-- 滑动tab--start -->
			<ul class="slide-tab">
				<li
					v-for="(item, index) in silideList"
					:key="index"
					:class="{ active: activeSlideTabIndex === index }"
					@click="changeSlideTab(index)"
				>
					{{ item.name }}
					<!-- <span class="num">{{ item.num }}</span> -->
					<span v-if="item.isVip" class="tag-member-mini tag-member--vip">VIP</span>
				</li>
			</ul>
			<!-- 滑动tab--start -->

			<!-- 表格echars--start -->
			<div class="table-container">
				<!-- 企业资质信息--start -->
				<div class="tab-container mt20">
					<div class="cjt-tabs">
						<div class="section-sub-title slideTitle">
							<h4>企业资质信息</h4>
						</div>
						<div class="cjt-tabs__content">
							<!-- 注册信息表格 -->
							<div class="register-table mt20 pdm20">
								<data-table
									:table-data="cerInfoList"
									:column="cerInfoColumns"
									:page-options="cerInfoPageOptions"
									:border="false"
									:loading="cerInfoLoading"
									@page-change="handleCerPaginationChange"
									:index="true"
								>
									<template slot="slot_tools" slot-scope="data">
										<el-button type="text" @click="handleOpenDialog('certSourceDetails', '证书记录', data.scope.row)">
											证书记录
										</el-button>
									</template>
								</data-table>
							</div>
						</div>
					</div>
				</div>
				<!-- 企业资质信息--end -->

				<!-- 企业人员--start -->
				<div class="tab-container mt20">
					<div class="cjt-tabs">
						<div class="section-sub-title slideTitle">
							<h4>企业人员</h4>
						</div>
						<div class="cjt-tabs__content">
							<!-- 注册信息表格 -->
							<div class="register-table mt20 pdm20">
								<data-table
									:table-data="personCertificateList"
									:column="personCertificateColumns"
									:page-options="personCertificatePageOptions"
									:border="false"
									:loading="personCertificateLoading"
									@page-change="handlePersonPaginationChange"
									:index="true"
								>
									<template slot="slot_personName" slot-scope="data">
										<span style="cursor: pointer;" @click="toPersonDetail(data.scope.row.personId)">
											{{ data.scope.row.personName }}
										</span>
									</template>

									<template slot="certificateGrade" slot-scope="data">
										{{ data.scope.row.certificateGrade ? data.scope.row.certificateGrade : '无' }}
									</template>

									<template slot="slot_tools" slot-scope="data">
										<el-button type="text" @click="handleOpenDialog('CertificateInfoVoDetail', '证书记录', data.scope.row)">
											证书记录
										</el-button>
									</template>
								</data-table>
							</div>
						</div>
					</div>
				</div>
				<!-- 企业人员--end -->

				<!-- 工程项目--start -->
				<div class="tab-container mt20">
					<div class="cjt-tabs">
						<div class="section-sub-title slideTitle">
							<h4>工程项目</h4>
						</div>
						<!--搜索框-->
						<div class="search-box">
							<el-form ref="projectSearchForm" :model="projectSearchForm" label-width="80px" class="projectSearch-form">
								<el-form-item label="项目名称">
									<el-input v-model="projectSearchForm.projectName" placeholder="请输入项目名称"></el-input>
								</el-form-item>
								<el-form-item label="工程类别">
									<el-select v-model="projectSearchForm.projectType" placeholder="请选择">
										<el-option
											v-for="item in projectCategoryDict"
											:key="item.id"
											:label="item.dictValue"
											:value="item.dictCode"
										></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="所属地区">
									<el-cascader
										ref="xmAddress"
										v-model="addressList"
										:options="divisionHbDictList"
										:props="cityDictProps"
										style="width: 100%"
										@change="xmAddressAfterChange"
									></el-cascader>
								</el-form-item>
								<!-- 查询、重置按钮 -->
								<el-row>
									<el-button type="primary" @click="searchProject">查询</el-button>
									<el-button @click="resetProject" style="margin-left: 30px;">重置</el-button>
								</el-row>
							</el-form>
						</div>
						<div class="cjt-tabs__content">
							<!-- 注册信息表格 -->
							<div class="register-table mt20 pdm20">
								<data-table
									:table-data="projectList"
									:column="projectColumns"
									:page-options="projectPageOptions"
									:border="false"
									:loading="projectLoading"
									@page-change="handleProjectPaginationChange"
									:index="true"
								>
									<template slot="slot_tools" slot-scope="data">
										<el-button type="text" @click="handleOpenDialog('projectDetail', '项目详情', data.scope.row)">
											查看
										</el-button>
									</template>
								</data-table>
							</div>
						</div>
					</div>
				</div>
				<!-- 工程项目--end -->

				<!-- 业绩技术指标--start -->
				<div class="tab-container mt20">
					<div class="cjt-tabs">
						<div class="section-sub-title slideTitle">
							<h4>业绩技术指标</h4>
						</div>
						<div class="cjt-tabs__content">
							<!-- 注册信息表格 -->
							<div class="register-table mt20 pdm20">
								<data-table
									:table-data="performanceList"
									:column="performanceColumns"
									:page-options="performancePageOptions"
									:border="false"
									:loading="performanceLoading"
									@page-change="handlePerformancePaginationChange"
									:index="true"
								>
									<template slot="slot_tools" slot-scope="data">
										<el-button
											type="text"
											@click="handleOpenDialog('PerformanceIndicatorDetails', '业绩技术指标详情', data.scope.row)"
										>
											查看
										</el-button>
									</template>
								</data-table>
							</div>
							<!-- 未开通会员提示 -->
							<nonbind-vip v-if="isNormalVip"></nonbind-vip>
						</div>
					</div>
				</div>
				<!-- 业绩技术指标--end -->

				<!-- 良好行为--start -->
				<div class="tab-container mt20">
					<div class="cjt-tabs">
						<div class="section-sub-title slideTitle">
							<h4>良好行为</h4>
						</div>
						<div class="cjt-tabs__content">
							<!-- 注册信息表格 -->
							<div class="register-table mt20 pdm20">
								<data-table
									:table-data="goodBehaviorList"
									:column="goodBehaviorColumns"
									:page-options="goodBehaviorPageOptions"
									:border="false"
									:loading="goodBehaviorLoading"
									@page-change="handleGoodPaginationChange"
									:index="true"
								>
									<template slot="slot_subjectCode" slot-scope="data">
										{{ data.scope.row.companyName || '' + ' ' + data.scope.row.subjectCode }}
									</template>
									<template slot="slot_tools" slot-scope="data">
										<el-button type="text" @click="handleOpenDialog('GoodCompanyBehaviorDetail', '良好行为详情', data.scope.row)">
											查看
										</el-button>
									</template>
								</data-table>
							</div>
							<!-- 未开通会员提示 -->
							<nonbind-vip v-if="isNormalVip"></nonbind-vip>
						</div>
					</div>
				</div>
				<!-- 良好行为--end -->

				<!-- 不良行为--start -->
				<div class="tab-container mt20">
					<div class="cjt-tabs">
						<div class="section-sub-title slideTitle">
							<h4>不良行为</h4>
						</div>
						<div class="cjt-tabs__content">
							<!-- 注册信息表格 -->
							<div class="register-table mt20 pdm20">
								<data-table
									:table-data="badBehaviorList"
									:column="badBehaviorColumns"
									:page-options="badBehaviorPageOptions"
									:border="false"
									:loading="badBehaviorLoading"
									@page-change="handleBadPaginationChange"
									:index="true"
								>
									<template slot="slot_subjectCode" slot-scope="data">
										{{ data.scope.row.companyName || '' + ' ' + data.scope.row.subjectCode }}
									</template>
									<template slot="slot_tools" slot-scope="data">
										<el-button type="text" @click="handleOpenDialog('BadCompanyBehaviorDetail', '不良行为详情', data.scope.row)">
											查看
										</el-button>
									</template>
								</data-table>
							</div>
							<!-- 未开通会员提示 -->
							<nonbind-vip v-if="isNormalVip"></nonbind-vip>
						</div>
					</div>
				</div>
				<!-- 不良行为--end -->

				<!-- 行政处罚--start -->
				<div class="tab-container mt20">
					<div class="cjt-tabs">
						<div class="section-sub-title slideTitle">
							<h4>行政处罚</h4>
						</div>
						<div class="cjt-tabs__content">
							<!-- 注册信息表格 -->
							<div class="register-table mt20 pdm20">
								<data-table
									:table-data="punishmentList"
									:column="punishmentColumns"
									:page-options="punishmentPageOptions"
									:border="false"
									:loading="punishmentLoading"
									@page-change="handlePunishPaginationChange"
									:index="true"
								>
									<template slot="slot_subjectCode" slot-scope="data">
										{{ data.scope.row.companyName || '' + ' ' + data.scope.row.subjectCode }}
									</template>
									<template slot="slot_tools" slot-scope="data">
										<el-button type="text" @click="handleOpenDialog('PunishmentCompanyDetail', '行政处罚详情', data.scope.row)">
											查看
										</el-button>
									</template>
								</data-table>
							</div>
							<!-- 未开通会员提示 -->
							<nonbind-vip v-if="isNormalVip"></nonbind-vip>
						</div>
					</div>
				</div>
				<!-- 行政处罚--end -->

				<!-- 黑名单记录--start -->
				<div class="tab-container mt20">
					<div class="cjt-tabs">
						<div class="section-sub-title slideTitle">
							<h4>黑名单记录</h4>
						</div>
						<div class="cjt-tabs__content">
							<!-- 注册信息表格 -->
							<div class="register-table mt20 pdm20">
								<data-table
									:table-data="blackList"
									:column="blackListColumns"
									:page-options="blackListPageOptions"
									:border="false"
									:loading="blackListLoading"
									@page-change="handleBlackPaginationChange"
									:index="true"
								>
									<template slot="slot_subjectCode" slot-scope="data">
										{{ data.scope.row.companyName || '' + ' ' + data.scope.row.subjectCode }}
									</template>
									<template slot="slot_tools" slot-scope="data">
										<el-button type="text" @click="handleOpenDialog('blackListCompanyDetail', '黑名单记录详情', data.scope.row)">
											查看
										</el-button>
									</template>
								</data-table>
							</div>
							<!-- 未开通会员提示 -->
							<nonbind-vip v-if="isNormalVip"></nonbind-vip>
						</div>
					</div>
				</div>
				<!-- 黑名单记录--end -->

				<!-- 资质证书变更记录--start -->
				<div class="tab-container mt20">
					<div class="cjt-tabs">
						<div class="section-sub-title slideTitle">
							<h4>资质证书变更记录</h4>
						</div>
						<div class="cjt-tabs__content mt20" v-loading="changeListLoading">
							<div class="section-dot-title">信息变更</div>
							<div class="time-line-container">
								<div ref="timeLineSwiperOne" class="swiper-container">
									<div class="swiper-wrapper">
										<div v-for="(item, index) in zcChangeList" :key="index" class="swiper-slide time-line-item">
											<div class="top-info">
												<div class="info-item" :title="item.content">变更内容：{{ item.content }}</div>
												<div class="info-item" :title="`${item.oldLegalPersonName || ''} ${item.oldRegisterCapital || ''}`">
													变更前：{{ item.oldLegalPersonName }} {{ item.oldRegisterCapital }}
												</div>
												<div class="info-item" :title="`${item.newLegalPersonName || ''} ${item.newRegisterCapital || ''}`">
													变更后：{{ item.newLegalPersonName }} {{ item.newRegisterCapital }}
												</div>
											</div>
											<div class="line"></div>
											<div class="time">{{ item.changeDate }}</div>
										</div>
									</div>
								</div>
							</div>
							<div class="section-dot-title">分立变更</div>
							<div class="time-line-container">
								<div ref="timeLineSwiperTwo" class="swiper-container">
									<div class="swiper-wrapper">
										<div v-for="(item, index) in flChangeList" :key="index" class="swiper-slide time-line-item">
											<div class="top-info">
												<div class="info-item" :title="item.companyName">分立企业名称：{{ item.companyName }}</div>
												<div class="info-item" :title="item.content">分立资质项：{{ item.content }}</div>
												<div class="info-item" :title="item.otherCompanyName">吸收企业名称：{{ item.otherCompanyName }}</div>
											</div>
											<div class="line"></div>
											<div class="time">{{ item.changeDate }}</div>
										</div>
									</div>
								</div>
							</div>
							<div class="section-dot-title">吸收变更</div>
							<div class="time-line-container">
								<div ref="timeLineSwiperThree" class="swiper-container">
									<div class="swiper-wrapper">
										<div v-for="(item, index) in xsChangeList" :key="index" class="swiper-slide time-line-item">
											<div class="top-info">
												<div class="info-item" :title="item.companyName">吸收企业名称：{{ item.companyName }}</div>
												<div class="info-item" :title="item.content">吸收资质项：{{ item.content }}</div>
												<div class="info-item" :title="item.otherCompanyName">分立企业名称：{{ item.otherCompanyName }}</div>
											</div>
											<div class="line"></div>
											<div class="time">{{ item.changeDate }}</div>
										</div>
									</div>
								</div>
							</div>
							<!-- 未开通会员提示 -->
							<nonbind-vip v-if="isNormalVip"></nonbind-vip>
						</div>
					</div>
				</div>
				<!-- 资质证书变更记录--end -->

				<!-- 失信联合惩戒记录--start -->
				<div class="tab-container mt20">
					<div class="cjt-tabs">
						<div class="section-sub-title slideTitle">
							<h4>失信联合惩戒记录</h4>
						</div>
						<div class="cjt-tabs__content">
							<!-- 注册信息表格 -->
							<div class="register-table mt20 pdm20">
								<data-table
									:table-data="unionList"
									:column="unionListColumns"
									:page-options="unionListPageOptions"
									:border="false"
									:loading="unionListLoading"
									@page-change="handleUnionPaginationChange"
									:index="true"
								>
									<template slot="slot_tools" slot-scope="data">
										<el-button
											type="text"
											@click="handleOpenDialog('punishDishonestyDetail', '失信联合惩戒记录', data.scope.row)"
										>
											查看
										</el-button>
									</template>
								</data-table>
							</div>
							<!-- 未开通会员提示 -->
							<nonbind-vip v-if="isNormalVip"></nonbind-vip>
						</div>
					</div>
				</div>
				<!-- 失信联合惩戒记录--end -->

				<div class="tab-container mt20">
					<div class="cjt-tabs">
						<div class="section-sub-title slideTitle">
							<h4>企业分析</h4>
						</div>
						<div class="cjt-tabs__content mt20">
							<div class="charts-content">
								<div class="charts-flx">
									<div class="charts-big">
										<div class="section-dot-title">证件数量分析</div>

										<div v-loading="certCountAnalyseLoading" class="charts-box">
											<enterprise-progress-chart
												ref="certCountChart"
												:value="certCountRank.percentile"
												:title="certCountRank.title"
												:sub-title="certCountRank.subTitle"
												color="#ff6a3d"
												height="410px"
												width="100%"
											/>

											<!-- 未开通会员提示 -->
											<nonbind-vip v-if="isNormalVip"></nonbind-vip>
										</div>
									</div>
									<div class="charts-big">
										<div class="section-dot-title">人员结构分析</div>
										<div v-loading="personAnalyseLoading" class="charts-box">
											<enterprise-pie-chart
												ref="structureOfPersonnelChart"
												:chart-data="structureOfPersonnelData"
												:show-legend="false"
												:show-label="true"
												height="410px"
												width="100%"
											/>

											<!-- 未开通会员提示 -->
											<nonbind-vip v-if="isNormalVip"></nonbind-vip>
										</div>
									</div>
								</div>
							</div>

							<div class="charts-content">
								<div class="charts-flx">
									<div class="charts-big">
										<div class="section-dot-title">证书类型分析</div>
										<div v-loading="certTypeAnalyseLoading" class="charts-box">
											<enterprise-donut-chart
												ref="certTypeChart"
												:chart-data="certTypeData"
												:center-text="certTypeTotal"
												height="410px"
												width="100%"
											/>

											<!-- 未开通会员提示 -->
											<nonbind-vip v-if="isNormalVip"></nonbind-vip>
										</div>
									</div>
									<div class="charts-big">
										<div class="section-dot-title">资质等级对比</div>
										<div v-loading="certGradeAnalyseLoading" class="charts-box">
											<enterprise-industry-bar-chart
												ref="industryChart"
												:enterprise-series-data="enterpriseSeriesData"
												:average-series-data="averageSeriesData"
												:x-axis-data="industryType"
												height="410px"
												width="100%"
											/>

											<!-- 未开通会员提示 -->
											<nonbind-vip v-if="isNormalVip"></nonbind-vip>
										</div>
									</div>
								</div>
							</div>

							<div class="charts-content">
								<div class="charts-flx">
									<div class="charts-big">
										<div class="section-dot-title">企业行为记录</div>
										<div v-loading="behaviorAnalyseLoading" class="charts-box">
											<enterprise-behavior-bar-chart
												ref="behaviorChart"
												:good-behavior-data="goodBehaviorData"
												:bad-behavior-data="badBehaviorData"
												:blacklist-data="blacklistData"
												:month-data="behaviorMonthData"
												height="410px"
												width="100%"
											/>

											<!-- 未开通会员提示 -->
											<nonbind-vip v-if="isNormalVip"></nonbind-vip>
										</div>
									</div>
									<div class="charts-big">
										<div class="section-dot-title">企业变动分析</div>
										<div v-loading="changeAnalyseLoading" class="charts-box">
											<enterprise-stability-line-chart
												ref="changeAnalyseChart"
												:chart-data="changeAnalyseData"
												:x-axis-data="changeAnalyseMonth"
												height="454px"
											/>

											<!-- 未开通会员提示 -->
											<nonbind-vip v-if="isNormalVip"></nonbind-vip>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 表格echars--start -->

			<jr-dialog :visible.sync="showDialog" :title="dialogTitle" width="70%" :append-to-body="true" :show-btn="false">
				<template v-if="showDialog" slot="content">
					<component
						:is="currentDialogComponent"
						:companyCode="companyDetail.companyCode"
						:certCode="certCode"
						:id="currentDialogInfoId"
						:idCard="peopleIdCard"
						:is-risk="false"
						ref="dialogComponent"
					></component>
				</template>
			</jr-dialog>

			<!-- 购买会员弹窗 -->
			<jr-dialog :visible.sync="payVisible" width="840px" :show-btn="false" @close="handleVipCancel">
				<template slot="title">
					<!-- 自定义弹窗标题 -->
					<h4 class="model-title">
						<span>购买会员</span>
					</h4>
				</template>
				<template slot="content">
					<payment-dialog @payOrderSuccess="handlePayOrderSuccessCallback"></payment-dialog>
				</template>
			</jr-dialog>
		</div>
	</div>
</template>

<script>
	import Swiper from 'swiper'
	import 'swiper/css/swiper.css'
	import JrPagination from '@/components/Pagination'
	import RadarChart from '@/components/Chart/RadarChart.vue'
	import EnterpriseProgressChart from '@/components/Chart/EnterpriseProgressChart.vue'
	import EnterprisePieChart from '@/components/Chart/EnterprisePieChart.vue'
	import EnterpriseDonutChart from '@/components/Chart/EnterpriseDonutChart.vue'
	import EnterpriseBehaviorBarChart from '@/components/Chart/EnterpriseBehaviorBarChart.vue'
	import EnterpriseStabilityLineChart from '@/components/Chart/EnterpriseStabilityLineChart.vue'
	import EnterpriseIndustryBarChart from '@/components/Chart/EnterpriseIndustryBarChart.vue'
	import JrDialog from '@/components/Dialog'
	import NonbindVip from '@/components/NonBind/nonbindVip.vue'
	import DataTable from '@/components/JrTable/DataTable.vue'
	import PaymentDialog from '@/views/memberBenefits/paymentDialog.vue'
	import {
		getCompanyInfo,
		getCertInfo,
		pageProjectInfo,
		pageAchievementInfo,
		pagePersonCertificateInfo,
		pageCreditBehavior,
		getCompanyChangeRecord,
		getCompanyPortrayal,
		getCompanyCertCountAnalyse,
		getCompanyPersonAnalyse,
		getCompanyCertTypeAnalyse,
		getCompanyCertGradeAnalyse,
		getCompanyBehaviorAnalyse,
		getCompanyChangeAnalyse,
		exportCompnayReport
	} from '@/api/qualificationQuery/company'
	import { reportGenerationDownload } from '@/utils/request'
	import { mapGetters } from 'vuex'
	import { ENUM_MEMBER_BENEFIT } from '@/enum/memberBenefitRecord'
	import memberBenefitCheckerMixins from '@/mixins/memberBenefitCheckerMixins'
	import { mapDictionaries } from '@/store/dictionary-helper'
	// 引入企业资质详情信息
	import CertSourceDetails from './components/company/certSourceDetails.vue'
	// 人员证书记录
	import CertificateInfoVoDetail from './components/person/certificateInfoVoDetail.vue'
	// 良好行文详情
	import GoodCompanyBehaviorDetail from './components/company/companyBehaviorDetail.vue'
	// 不良行为详情
	import BadCompanyBehaviorDetail from './components/company/punishmentCompanyDetail.vue'
	// 处罚详情
	import PunishmentCompanyDetail from './components/company/punishmentCompanyDetail.vue'
	// 黑名单记录详情
	import blackListCompanyDetail from './components/company/blackListCompanyDetail.vue'
	// 失信及联合惩戒记录
	import PunishDishonestyDetail from './components/company/punishDishonestyDetail.vue'
	// 项目详情
	import projectDetail from './components/company/projectDetail.vue'
	// 业绩技术指标详情
	import PerformanceIndicatorDetails from './components/project/performanceIndicatorDetails.vue'
	import { saveUserCollect, removeUserCollect, saveUserMonitoring, removeUserMonitoring } from '@/api/userCenter/index'
	import { COLLECT_TYPE_STATE } from '@/enum/index'
	import { getDictFlattenList } from '@/api/dictionary/index'
	export default {
		name: 'CompanyDetail',
		components: {
			JrPagination,
			RadarChart,
			EnterpriseProgressChart,
			EnterprisePieChart,
			EnterpriseDonutChart,
			EnterpriseBehaviorBarChart,
			EnterpriseStabilityLineChart,
			EnterpriseIndustryBarChart,
			JrDialog,
			NonbindVip,
			DataTable,
			CertSourceDetails,
			CertificateInfoVoDetail,
			GoodCompanyBehaviorDetail,
			BadCompanyBehaviorDetail,
			PunishmentCompanyDetail,
			blackListCompanyDetail,
			PunishDishonestyDetail,
			PaymentDialog,
			projectDetail,
			PerformanceIndicatorDetails
		},
		// 使用会员权益前置校验mixins
		mixins: [memberBenefitCheckerMixins],
		props: {},
		data() {
			return {
				// 购买会员弹窗
				payVisible: false,
				itemWidth: 350,
				isCollect: true,
				isMonitor: true,
				activeSlideTabIndex: 0,
				vipMessages: [
					{ message: '李** 于3分钟前购买会员，一键解锁全部权益' },
					{ message: '王** 于5分钟前购买会员，一键解锁全部权益' },
					{ message: '张** 于10分钟前购买会员，一键解锁全部权益' }
				],
				silideList: [
					{
						name: '企业资质信息',
						isVip: false
					},
					{
						name: '企业人员',
						isVip: false
					},
					{
						name: '工程项目',
						isVip: false
					},
					{
						name: '业绩技术指标',
						isVip: true
					},
					{
						name: '良好行为',
						isVip: true
					},
					{
						name: '行政处罚',
						isVip: true
					},
					{
						name: '黑名单记录',
						isVip: true
					},
					{
						name: '资质证书变更记录',
						isVip: true
					},
					{
						name: '失信联合惩戒记录',
						isVip: true
					}
				],
				// 企业资质信息表格数据
				cerInfoList: [],
				cerInfoPageOptions: {
					page: 1,
					limit: 10,
					total: 0
				},
				cerInfoColumns: [
					{ prop: 'certName', label: '资质类别', align: 'center' },
					{ prop: 'certCode', label: '证书编号', align: 'center' },
					{ prop: 'certInfoName', label: '资质名称', align: 'center' },
					{ prop: 'makeTime', label: '发证日期', align: 'center' },
					{ prop: 'endTime', label: '发证有效期', align: 'center' },
					{ prop: 'makeUnit', label: '发证机关', align: 'center' },
					{ label: '操作', prop: '', align: 'center', slot: 'slot_tools' }
				],
				cerInfoLoading: false,
				// 企业人员表格数据
				personCertificateList: [],
				personCertificatePageOptions: {
					page: 1,
					limit: 10,
					total: 0
				},
				personCertificateColumns: [
					{ prop: 'personName', label: '姓名', align: 'center', slot: 'slot_personName' },
					{ prop: 'sex', label: '性别', align: 'center' },
					{ prop: 'certType', label: '证件类型', align: 'center' },
					{ prop: 'idCard', label: '证件号码', align: 'center', width: 180 },
					{ prop: 'certificateName', label: '证书类型', align: 'center' },
					{ prop: 'registerProject', label: '注册专业', align: 'center' },
					{ prop: 'registerCode', label: '执业印章号', align: 'center' },
					{ prop: 'certificateGrade', label: '等级', align: 'center', slot: 'certificateGrade' },
					{ prop: 'certificateCode', label: '证书编号', align: 'center' },
					{ prop: 'registerTime', label: '发证日期', align: 'center' },
					{ prop: 'validityTime', label: '有效期', align: 'center' },
					{ label: '操作', prop: '', align: 'center', slot: 'slot_tools' }
				],
				personCertificateLoading: false,
				// 工程项目表格数据
				projectList: [],
				projectPageOptions: {
					page: 1,
					limit: 10,
					total: 0
				},
				projectColumns: [
					{ prop: 'projectName', label: '项目名称', align: 'center' },
					{ prop: 'address', label: '项目地址', align: 'center' },
					{ prop: 'projectType', label: '工程类别', align: 'center' },
					{ prop: 'projectCode', label: '项目编码', align: 'center' },
					{ prop: 'addressName', label: '所属地区', align: 'center' },
					{ label: '操作', prop: '', align: 'center', slot: 'slot_tools' }
				],
				projectLoading: false,
				// 业绩技术指标表格数据
				performanceList: [],
				performancePageOptions: {
					page: 1,
					limit: 10,
					total: 0
				},
				performanceColumns: [
					{ prop: 'dataLevel', label: '数据等级', align: 'center' },
					{ prop: 'projectName', label: '项目名称', align: 'center' },
					{ prop: 'performanceCode', label: '业绩记录标号', align: 'center' },
					{ prop: 'projectCode', label: '项目编号', align: 'center' },
					{ prop: 'performanceTypeName', label: '业绩类型', align: 'center' },
					{ prop: 'performanceIndicator', label: '业绩内容', align: 'center' },
					{ label: '操作', prop: '', align: 'center', slot: 'slot_tools' }
				],
				performanceLoading: false,
				// 良好行为表格数据
				goodBehaviorList: [],
				goodBehaviorPageOptions: {
					page: 1,
					limit: 10,
					total: 0
				},
				goodBehaviorColumns: [
					{ prop: 'subjectCode', label: '诚信记录主体及编号', align: 'center', slot: 'slot_subjectCode' },
					{ prop: 'awardIntro', label: '决定内容', align: 'center' },
					{ prop: 'awardDept', label: '实施部门', align: 'center' },
					{ prop: 'decideDate', label: '决定日期与有效期', align: 'center' },
					{ label: '操作', prop: '', align: 'center', slot: 'slot_tools' }
				],
				goodBehaviorLoading: false,
				// 不良行为表格数据
				badBehaviorList: [],
				badBehaviorPageOptions: {
					page: 1,
					limit: 10,
					total: 0
				},
				badBehaviorColumns: [
					{ prop: 'subjectCode', label: '诚信记录主体及编号', align: 'center', slot: 'slot_subjectCode' },
					{ prop: 'awardIntro', label: '决定内容', align: 'center' },
					{ prop: 'awardDept', label: '实施部门', align: 'center' },
					{ prop: 'decideDate', label: '决定日期与有效期', align: 'center' },
					{ label: '操作', prop: '', align: 'center', slot: 'slot_tools' }
				],
				badBehaviorLoading: false,
				// 行政处罚表格数据
				punishmentList: [],
				punishmentPageOptions: {
					page: 1,
					limit: 10,
					total: 0
				},
				punishmentColumns: [
					{ prop: 'subjectCode', label: '行政处罚主体及编号', align: 'center', slot: 'slot_subjectCode' },
					{ prop: 'awardIntro', label: '内容描述', align: 'center' },
					{ prop: 'registerDept', label: '登记部门', align: 'center' },
					{ prop: 'registerDate', label: '登记时间', align: 'center' },
					{ label: '操作', prop: '', align: 'center', slot: 'slot_tools' }
				],
				punishmentLoading: false,
				// 黑名单记录表格数据
				blackList: [],
				blackListPageOptions: {
					page: 1,
					limit: 10,
					total: 0
				},
				blackListColumns: [
					{ prop: 'subjectCode', label: '黑名单主体及编号', align: 'center', slot: 'slot_subjectCode' },
					{ prop: 'awardIntro', label: '黑名单认定依据', align: 'center' },
					{ prop: 'registerDept', label: '认定部门', align: 'center' },
					{ prop: 'registerDate', label: '决定期与有效期', align: 'center' },
					{ prop: 'remark', label: '备注', align: 'center' },
					{ label: '操作', prop: '', align: 'center', slot: 'slot_tools' }
				],
				blackListLoading: false,
				// 注册变更
				zcChangeList: [],
				// 分立变更
				flChangeList: [],
				// 吸收变更
				xsChangeList: [],
				changeListLoading: false,
				// 失信联合惩戒记录
				unionList: [],
				unionListPageOptions: {
					page: 1,
					limit: 10,
					total: 0
				},
				unionListColumns: [
					{ prop: 'subjectCode', label: '失信记录编号', align: 'center' },
					{ prop: 'companyName', label: '失信联合惩戒记录主体', align: 'center' },
					{ prop: 'legalPerson', label: '法人姓名', align: 'center' },
					{ prop: 'awardIntro', label: '列入名单事由', align: 'center' },
					{ prop: 'registerDept', label: '认定部门', align: 'center' },
					{ prop: 'registerDate', label: '列入日期', align: 'center' },
					{ label: '操作', prop: '', align: 'center', slot: 'slot_tools' }
				],
				unionListLoading: false,
				showDialog: false,
				dialogTitle: '',
				currentDialogComponent: '',
				// 企业id
				companyId: null,
				// 企业详情加载
				loading: false,
				// 企业详情
				companyDetail: {},
				// 证书编号
				certCode: '',
				// 当前弹窗查看的信息id
				currentDialogInfoId: '',
				// 人员身份证
				peopleIdCard: '',
				// 工程项目搜索
				projectSearchForm: {
					// 项目名称
					projectName: '',
					// 工程类别
					projectType: '',
					// 所属市州
					provinceCode: '',
					cityCode: '',
					countyCode: ''
				},
				// 省级区划
				addressList: [],
				divisionHbDictList: [],
				cityDictProps: {
					label: 'dictValue',
					value: 'dictCode',
					children: 'children',
					isLeaf: 'isLeaf'
				},
				allAddressDict: [],

				// 企业画像雷达图数据
				portraitIndicator: [
					{ name: '资质', max: 5 },
					{ name: '稳定性', max: 5 },
					{ name: '规模', max: 5 },
					{ name: '业绩', max: 5 },
					{ name: '风险', max: 5 }
				],
				// 企业画像数据
				portraitData: [
					{
						value: [],
						name: '企业能力'
					}
				],
				portraitLoading: false,

				// 企业证件数量及其占比
				certCountRank: {
					// 占比
					percentile: 0,
					title: '',
					subTitle: '证件数量超过同类企业'
				},
				certCountAnalyseLoading: false,

				// 企业人员结构数据
				structureOfPersonnelData: [
					// { value: 25, name: '一级注册建造师' },
				],
				personAnalyseLoading: false,
				// 证书类型分析数据
				certTypeData: [],
				// 证书类型总数
				certTypeTotal: '',
				certTypeAnalyseLoading: false,

				// 企业行为记录-良好行为
				goodBehaviorData: [],
				// 企业行为记录-不良行为
				badBehaviorData: [],
				// 企业行为记录-黑名单
				blacklistData: [],
				// 横坐标-月份
				behaviorMonthData: [],
				behaviorAnalyseLoading: false,

				// 本企业资质等级数据
				enterpriseSeriesData: [],
				// 行业平均
				averageSeriesData: [],
				// 资质等级集合（横坐标）
				industryType: [],
				certGradeAnalyseLoading: false,

				// 企业变动分析数据
				changeAnalyseData: [],
				// 企业变动分析数据横轴坐标
				changeAnalyseMonth: [],
				changeAnalyseLoading: false,

				// 所有图表数据是否全部加载完毕，便于进行报告导出
				allChartDataIsLoadingDone: false
			}
		},
		computed: {
			...mapGetters(['vipLevel', 'isNormalVip', 'isVip', 'isSVip']),
			...mapDictionaries('dictionary', ['projectCategoryDict'])
		},
		watch: {},
		created() {},
		async mounted() {
			if (this.$route.query && this.$route.query.id) {
				this.companyId = this.$route.query.id
				await this.initCompanyDetail()
			}
			await this.handleGetHbDivision()
			this.initSwiper()
			// this.initTimeLineSwiper(this.$refs.timeLineSwiperOne)
			// this.initTimeLineSwiper(this.$refs.timeLineSwiperTwo)
			// this.initTimeLineSwiper(this.$refs.timeLineSwiperThree)

			// 获取企业资质信息方法
			this.getCerInfo()
			// 查询企业人员信息方法
			this.getPersonInfo()
			// 获取工程项目信息方法
			this.getProjectInfo()
			// 高级会员、超级会员，才会以下方法
			if (this.isVip || this.isSVip) {
				// 获取业绩技术指标信息方法
				this.getPerformanceInfo()
				// 获取良好行为信息方法
				this.getGoodBehaviorInfo()
				//获取不良行为信息方法
				this.getBadBehaviorInfo()
				// 获取行政处罚信息方法
				this.getPunishmentInfo()
				// 获取黑名单记录信息方法
				this.getBlackListInfo()
				// 获取变更记录信息方法
				this.getChangeInfo()
				// 获取失信联合惩戒记录信息方法
				this.getUnionInfo()

				// 所有图表分析数据加载promise
				const chartLoadingPromises = [
					// 获取企业画像
					this.initCompanyPortrayal(),
					this.getCompanyCertCountAnalyseData(),
					this.getCompanyPersonAnalyseData(),
					this.getCompanyCertTypeAnalyseData(),
					this.getCompanyCertGradeAnalyseData(),
					this.getCompanyBehaviorAnalyseData(),
					this.getCompanyChangeAnalyseData()
				]

				console.log('chartLoadingPromises:', chartLoadingPromises)

				// 等待所有图表数据加载完毕
				Promise.all(chartLoadingPromises)
					.then(() => {
						console.log('图表加载完毕')

						// 所有分析图表数据已加载完成
						this.allChartDataIsLoadingDone = true
					})
					.catch(error => {
						console.log('图表加载报错：', error)
						// 即使出现了报错也要标记为已完成，避免导致无限等待
						this.allChartDataIsLoadingDone = true
					})
			}
		},
		methods: {
			// 初始化详情基础信息
			async initCompanyDetail() {
				this.loading = true
				const params = {
					id: this.companyId
				}
				try {
					const res = await getCompanyInfo(params)
					this.companyDetail = res.data
					this.loading = false
				} catch (err) {
					this.loading = false
				}
			},
			// 初始化企业画像
			initCompanyPortrayal() {
				this.portraitLoading = true
				const params = {
					companyCode: this.companyDetail.companyCode
				}

				return new Promise((resolve, reject) => {
					getCompanyPortrayal(params)
						.then(res => {
							const { data } = res
							if (data) {
								this.portraitData[0].value = Object.values(data)
							}
							this.portraitLoading = false
							resolve()
						})
						.catch(error => {
							this.portraitLoading = false
							reject(error)
						})
				})
			},

			// 查询企业证件数量分析数据
			getCompanyCertCountAnalyseData() {
				this.certCountAnalyseLoading = true
				const params = {
					companyCode: this.companyDetail.companyCode
				}

				return new Promise((resolve, reject) => {
					getCompanyCertCountAnalyse(params)
						.then(response => {
							const { data } = response

							this.certCountAnalyseLoading = false

							if (data) {
								this.certCountRank.percentile = data.percentage
								this.certCountRank.title = data.percentage > 60 ? '高' : 50 < data.percentage <= 60 ? '中' : '低'
								this.certCountRank.subTitle = `证件数量超过${data.percentageStr}同类企业`
							}
							resolve()
						})
						.catch(error => {
							this.certCountAnalyseLoading = false
							reject(error)
						})
				})
			},

			// 查询企业人员结构分析数据
			getCompanyPersonAnalyseData() {
				this.personAnalyseLoading = true
				const params = {
					companyCode: this.companyDetail.companyCode
				}

				return new Promise((resolve, reject) => {
					getCompanyPersonAnalyse(params)
						.then(response => {
							const { data } = response

							this.personAnalyseLoading = false

							if (data && data.length) {
								this.structureOfPersonnelData = data.map(item => ({
									value: item.typeCount,
									name: item.certificateName
								}))
							}
							resolve()
						})
						.catch(error => {
							this.personAnalyseLoading = false
							reject(error)
						})
				})
			},

			// 查询企业证书类型分析数据
			getCompanyCertTypeAnalyseData() {
				this.certTypeAnalyseLoading = true
				const params = {
					companyCode: this.companyDetail.companyCode
				}

				return new Promise((resolve, reject) => {
					getCompanyCertTypeAnalyse(params)
						.then(response => {
							const { data } = response

							this.certTypeAnalyseLoading = false

							if (data && data.length) {
								this.certTypeData = data.map(item => ({
									value: item.typeCount,
									name: item.certName
								}))

								this.certTypeTotal =
									data.reduce((sum, item) => {
										return sum + parseInt(item.typeCount, 10)
									}, 0) + '本'
							}
							resolve()
						})
						.catch(error => {
							this.certTypeAnalyseLoading = false
							reject(error)
						})
				})
			},

			// 查询企业资质等级对比分析数据
			getCompanyCertGradeAnalyseData() {
				this.certGradeAnalyseLoading = true
				const params = {
					companyCode: this.companyDetail.companyCode
				}

				return new Promise((resolve, reject) => {
					getCompanyCertGradeAnalyse(params)
						.then(response => {
							const { data } = response

							this.certGradeAnalyseLoading = false

							if (data && data.length) {
								this.enterpriseSeriesData = data.map(item => item.companyCertInfoCount)
								this.averageSeriesData = data.map(item => item.certInfoAvg)
								this.industryType = data.map(item => item.certInfoGrade)
							}
							resolve()
						})
						.catch(error => {
							this.certGradeAnalyseLoading = false
							reject(error)
						})
				})
			},

			// 查询企业行为记录分析数据
			getCompanyBehaviorAnalyseData() {
				this.behaviorAnalyseLoading = true
				const params = {
					companyCode: this.companyDetail.companyCode
				}

				return new Promise((resolve, reject) => {
					getCompanyBehaviorAnalyse(params)
						.then(response => {
							const { data } = response

							this.behaviorAnalyseLoading = false

							if (data && data.length) {
								this.goodBehaviorData = data.map(item => item.good)
								this.badBehaviorData = data.map(item => item.badness)
								this.blacklistData = data.map(item => item.blacklist)
								this.behaviorMonthData = data.map(item => {
									const monthNumber = parseInt(item.month, 10)
									return `${monthNumber}月`
								})
							}
							resolve()
						})
						.catch(error => {
							this.behaviorAnalyseLoading = false
							reject(error)
						})
				})
			},

			// 查询企业变动分析数据
			getCompanyChangeAnalyseData() {
				this.changeAnalyseLoading = true
				const params = {
					companyCode: this.companyDetail.companyCode
				}

				return new Promise((resolve, reject) => {
					getCompanyChangeAnalyse(params)
						.then(response => {
							const { data } = response

							this.changeAnalyseLoading = false

							if (data && data.length) {
								this.changeAnalyseMonth = data.map(item => {
									const monthNumber = parseInt(item.month, 10)
									return `${monthNumber}月`
								})
								this.changeAnalyseData = data.map(item => item.value)
							}
							resolve()
						})
						.catch(error => {
							this.changeAnalyseLoading = false
							reject(error)
						})
				})
			},

			// 获取企业资质信息
			getCerInfo() {
				this.cerInfoLoading = true
				const params = {
					page: this.cerInfoPageOptions.page,
					limit: this.cerInfoPageOptions.limit,
					companyCode: this.companyDetail.companyCode
				}
				getCertInfo(params)
					.then(res => {
						this.cerInfoList = res.data.records
						this.cerInfoPageOptions.total = res.data.total
						this.cerInfoLoading = false
					})
					.catch(err => {
						this.cerInfoLoading = false
					})
			},

			// 查询企业人员信息
			getPersonInfo() {
				this.personCertificateLoading = true
				const params = {
					page: this.personCertificatePageOptions.page,
					limit: this.personCertificatePageOptions.limit,
					companyCode: this.companyDetail.companyCode
				}
				pagePersonCertificateInfo(params)
					.then(res => {
						this.personCertificateList = res.data.records
						this.personCertificatePageOptions.total = res.data.total
						this.personCertificateLoading = false
					})
					.catch(err => {
						this.personCertificateLoading = false
					})
			},

			// 获取工程项目信息
			getProjectInfo() {
				this.projectLoading = true
				const params = {
					page: this.projectPageOptions.page,
					limit: this.projectPageOptions.limit,
					companyCode: this.companyDetail.companyCode,
					...this.projectSearchForm
				}
				pageProjectInfo(params)
					.then(res => {
						res.data.records = res.data.records.map(item => ({
							...item,
							addressName: [
								this.allAddressDict.find(e => item.cityCode === e.dictCode)?.dictValue || '',
								this.allAddressDict.find(e => item.countyCode === e.dictCode)?.dictValue || ''
							].join('')
						}))
						this.projectList = res.data.records
						this.projectPageOptions.total = res.data.total
						this.projectLoading = false
					})
					.catch(err => {
						this.projectLoading = false
					})
			},

			// 获取业绩技术指标信息
			getPerformanceInfo() {
				this.performanceLoading = true
				const params = {
					page: this.performancePageOptions.page,
					limit: this.performancePageOptions.limit,
					companyCode: this.companyDetail.companyCode
				}
				pageAchievementInfo(params)
					.then(res => {
						this.performanceList = res.data.records
						this.performancePageOptions.total = res.data.total
						this.performanceLoading = false
					})
					.catch(err => {
						this.performanceLoading = false
					})
			},

			// 获取良好行为信息
			getGoodBehaviorInfo() {
				this.goodBehaviorLoading = true
				const params = {
					page: this.goodBehaviorPageOptions.page,
					limit: this.goodBehaviorPageOptions.limit,
					companyCode: this.companyDetail.companyCode,
					behaviorType: 1
				}
				pageCreditBehavior(params)
					.then(res => {
						this.goodBehaviorList = res.data.records
						this.goodBehaviorPageOptions.total = res.data.total
						this.goodBehaviorLoading = false
					})
					.catch(err => {
						this.goodBehaviorLoading = false
					})
			},

			// 获取不良行为信息
			getBadBehaviorInfo() {
				this.badBehaviorLoading = true
				const params = {
					page: this.badBehaviorPageOptions.page,
					limit: this.badBehaviorPageOptions.limit,
					companyCode: this.companyDetail.companyCode,
					behaviorType: 0
				}
				pageCreditBehavior(params)
					.then(res => {
						this.badBehaviorList = res.data.records
						this.badBehaviorPageOptions.total = res.data.total
						this.badBehaviorLoading = false
					})
					.catch(err => {
						this.badBehaviorLoading = false
					})
			},

			// 获取行政处罚信息
			getPunishmentInfo() {
				this.punishmentLoading = true
				const params = {
					page: this.punishmentPageOptions.page,
					limit: this.punishmentPageOptions.limit,
					companyCode: this.companyDetail.companyCode,
					behaviorType: 2
				}
				pageCreditBehavior(params)
					.then(res => {
						this.punishmentList = res.data.records
						this.punishmentPageOptions.total = res.data.total
						this.punishmentLoading = false
					})
					.catch(err => {
						this.punishmentLoading = false
					})
			},
			// 获取黑名单记录信息
			getBlackListInfo() {
				this.blackListLoading = true
				const params = {
					page: this.blackListPageOptions.page,
					limit: this.blackListPageOptions.limit,
					companyCode: this.companyDetail.companyCode,
					behaviorType: 3
				}
				pageCreditBehavior(params)
					.then(res => {
						this.blackList = res.data.records
						this.blackListPageOptions.total = res.data.total
						this.blackListLoading = false
					})
					.catch(err => {
						this.blackListLoading = false
					})
			},
			// 获取变更记录信息
			getChangeInfo() {
				this.changeListLoading = true
				const params = {
					companyCode: this.companyDetail.companyCode
				}
				getCompanyChangeRecord(params)
					.then(res => {
						this.zcChangeList = res.data[0] || []
						this.flChangeList = res.data[1] || []
						this.xsChangeList = res.data[2] || []
						this.changeListLoading = false
						this.$nextTick(() => {
							if (this.zcChangeList.length >= 4) {
								this.initTimeLineSwiper(this.$refs.timeLineSwiperOne, 4)
							} else if (this.zcChangeList.length >= 3) {
								this.initTimeLineSwiper(this.$refs.timeLineSwiperOne, 3)
							} else if (this.zcChangeList.length >= 2) {
								this.initTimeLineSwiper(this.$refs.timeLineSwiperOne, 2)
							} else if (this.zcChangeList.length >= 1) {
								this.initTimeLineSwiper(this.$refs.timeLineSwiperOne, 1)
							}

							if (this.flChangeList.length >= 4) {
								this.initTimeLineSwiper(this.$refs.timeLineSwiperTwo, 4)
							} else if (this.flChangeList.length >= 3) {
								this.initTimeLineSwiper(this.$refs.timeLineSwiperTwo, 3)
							} else if (this.flChangeList.length >= 2) {
								this.initTimeLineSwiper(this.$refs.timeLineSwiperTwo, 2)
							} else if (this.flChangeList.length >= 1) {
								this.initTimeLineSwiper(this.$refs.timeLineSwiperTwo, 1)
							}

							if (this.xsChangeList.length >= 4) {
								this.initTimeLineSwiper(this.$refs.timeLineSwiperThree, 4)
							} else if (this.xsChangeList.length >= 3) {
								this.initTimeLineSwiper(this.$refs.timeLineSwiperThree, 3)
							} else if (this.xsChangeList.length >= 2) {
								this.initTimeLineSwiper(this.$refs.timeLineSwiperThree, 2)
							} else if (this.xsChangeList.length >= 1) {
								this.initTimeLineSwiper(this.$refs.timeLineSwiperThree, 1)
							}
						})
					})
					.catch(err => {
						this.changeListLoading = false
					})
			},

			// 获取失信联合惩戒记录
			getUnionInfo() {
				this.unionListLoading = true
				const params = {
					page: this.unionListPageOptions.page,
					limit: this.unionListPageOptions.limit,
					companyCode: this.companyDetail.companyCode,
					behaviorType: 4
				}
				pageCreditBehavior(params)
					.then(res => {
						this.unionList = res.data.records
						this.unionListPageOptions.total = res.data.total
						this.unionListLoading = false
					})
					.catch(err => {
						this.unionListLoading = false
					})
			},
			initTimeLineSwiper(refs, number) {
				// 检查 refs 是否为 DOM 元素
				const swiperEl = refs instanceof HTMLElement ? refs : refs.$el
				// 创建导航箭头元素
				const prevButton = document.createElement('div')
				prevButton.classList.add('swiper-button-prev')
				const nextButton = document.createElement('div')
				nextButton.classList.add('swiper-button-next')
				// 将箭头元素添加到滑动容器
				swiperEl.appendChild(prevButton)
				swiperEl.appendChild(nextButton)

				const swiper = new Swiper(swiperEl, {
					slidesPerView: number, // 每次显示 number 条
					spaceBetween: 0, // 间距 0px
					freeMode: true, // 自由滑动模式
					grabCursor: true, // 显示抓手光标
					mousewheel: true, // 允许鼠标滚轮控制
					// 配置导航箭头
					navigation: {
						prevEl: '.swiper-button-prev',
						nextEl: '.swiper-button-next'
					},
					// 初始化后检查是否显示导航
					on: {
						init: function() {
							if (this.slides.length <= this.params.slidesPerView) {
								prevButton.style.display = 'none'
								nextButton.style.display = 'none'
							} else {
								prevButton.style.display = 'block'
								nextButton.style.display = 'block'
							}
						},
						// 滑动时更新导航显示状态
						slideChange: function() {
							if (this.slides.length <= this.params.slidesPerView) {
								prevButton.style.display = 'none'
								nextButton.style.display = 'none'
							} else {
								prevButton.style.display = 'block'
								nextButton.style.display = 'block'
							}
						}
					}
				})
			},
			initSwiper() {
				new Swiper('.vip-swiper', {
					direction: 'vertical', // 垂直方向滚动
					loop: true, // 循环滚动
					autoplay: {
						delay: 3000, // 3秒切换一次
						disableOnInteraction: false
					},
					slidesPerView: 1, // 每次显示1条
					spaceBetween: 0 // 间距为0
				})
			},
			// 切换Tab
			changeSlideTab(index) {
				this.activeSlideTabIndex = index

				// 获取点击的tab名称
				const tabName = this.silideList[index].name

				// 查找所有slideTitle元素
				const titles = document.querySelectorAll('.slideTitle')
				let targetTitle = null

				// 遍历查找匹配的标题
				titles.forEach(title => {
					if (title.textContent.trim() === tabName) {
						targetTitle = title
					}
				})

				if (targetTitle) {
					this.$nextTick(() => {
						const elementPosition = targetTitle.getBoundingClientRect().top
						const offsetPosition = elementPosition + window.pageYOffset - 66

						window.scrollTo({
							top: offsetPosition,
							behavior: 'smooth'
						})
					})
				}
			},
			// 打开弹窗
			async handleOpenDialog(type, title, row) {
				// 证书记录,单独做处理
				// if (type === 'certSourceDetails') {
				// 	// 使用混入方法：校验项目详情页各个子表的会员权益是否使用完毕
				// 	const isValid = await this.validateMemberBenefit(ENUM_MEMBER_BENEFIT['ZSJL'])
				// 	if (!isValid) {
				// 		return
				// 	}
				// }
				// // 人员资质记录详情不用校验权益，其余查看详情子表都要权益校验
				// if (type !== 'CertificateInfoVoDetail' && type !== 'certSourceDetails') {
				// 	// 使用混入方法：校验项目详情页各个子表的会员权益是否使用完毕
				// 	const isValid = await this.validateMemberBenefit(ENUM_MEMBER_BENEFIT['JBXX_XQ'])
				// 	if (!isValid) {
				// 		return
				// 	}
				// }
				this.certCode = row.certCode
				this.currentDialogInfoId = row.id
				this.peopleIdCard = row.idCard
				this.currentDialogComponent = type
				this.showDialog = true
				this.dialogTitle = title
			},
			// 企业资质分页方法
			handleCerPaginationChange(pager) {
				const { page, limit } = pager
				this.cerInfoPageOptions.page = page
				this.cerInfoPageOptions.limit = limit
				this.getCerInfo()
			},
			// 企业人员分页方法
			handlePersonPaginationChange(pager) {
				const { page, limit } = pager
				this.personCertificatePageOptions.page = page
				this.personCertificatePageOptions.limit = limit
				this.getPersonInfo()
			},
			// 工程项目分页方法
			handleProjectPaginationChange(pager) {
				const { page, limit } = pager
				this.projectPageOptions.page = page
				this.projectPageOptions.limit = limit
				this.getProjectInfo()
			},
			// 业绩技术指标分页方法
			handlePerformancePaginationChange(pager) {
				const { page, limit } = pager
				this.performancePageOptions.page = page
				this.performancePageOptions.limit = limit
				this.getPerformanceInfo()
			},
			// 良好行为分页方法
			handleGoodPaginationChange(pager) {
				const { page, limit } = pager
				this.goodBehaviorPageOptions.page = page
				this.goodBehaviorPageOptions.limit = limit
				this.getGoodBehaviorInfo()
			},
			// 不良行为分页方法
			handleBadPaginationChange(pager) {
				const { page, limit } = pager
				this.badBehaviorPageOptions.page = page
				this.badBehaviorPageOptions.limit = limit
				this.getBadBehaviorInfo()
			},
			// 行政处罚分页方法
			handlePunishPaginationChange(pager) {
				const { page, limit } = pager
				this.punishmentPageOptions.page = page
				this.punishmentPageOptions.limit = limit
				this.getPunishmentInfo()
			},
			// 黑名单记录分页方法
			handleBlackPaginationChange(pager) {
				const { page, limit } = pager
				this.blackListPageOptions.page = page
				this.blackListPageOptions.limit = limit
				this.getBlackListInfo()
			},
			// 失信联合惩戒记录分页方法
			handleUnionPaginationChange(pager) {
				const { page, limit } = pager
				this.unionListPageOptions.page = page
				this.unionListPageOptions.limit = limit
				this.getUnionInfo()
			},
			// 收藏与取消收藏
			handleIsCollect(id, flag) {
				// if (!this.isVip && !this.isSVip) {
				// 	this.$message.error('暂不是高级会员，请先购买会员')
				// 	this.payVisible = true
				// 	return
				// }
				// 如果左侧企业信息还没获取出来，则直接return
				if (!id) {
					return
				}
				const params = {
					collectIds: [id],
					collectType: COLLECT_TYPE_STATE.ENTERPRISE
				}
				if (flag) {
					removeUserCollect(params).then(res => {
						this.$message.success('已取消收藏')
						this.companyDetail.isCollect = false
						// this.initCompanyDetail()
					})
				} else {
					saveUserCollect(params).then(res => {
						this.$message.success('收藏成功')
						this.companyDetail.isCollect = true
						// this.initCompanyDetail()
					})
				}
			},
			// 监控与取消监控
			handleIsMonitoring(id, flag) {
				if (!this.isVip && !this.isSVip) {
					this.$message.error('暂不是高级会员，请先购买会员')
					this.payVisible = true
					return
				}
				// 如果左侧企业信息还没获取出来，则直接return
				if (!id) {
					return
				}
				const params = {
					monitoringIds: [id],
					monitoringType: COLLECT_TYPE_STATE.ENTERPRISE
				}
				if (flag) {
					removeUserMonitoring(params).then(res => {
						this.$message.success('已取消监控')
						this.companyDetail.isMonitoring = true
						// this.initCompanyDetail()
					})
				} else {
					saveUserMonitoring(params).then(res => {
						this.$message.success('监控成功')
						this.companyDetail.isMonitoring = true
						// this.initCompanyDetail()
					})
				}
			},
			toPersonDetail(id) {
				const routeData = this.$router.resolve({
					path: '/qualification-query/personDetail',
					query: {
						id: id
					}
				})
				window.open(routeData.href, '_blank')
			},
			// 工程项目搜索
			searchProject() {
				this.getProjectInfo()
			},
			// 工程项目重置
			resetProject() {
				this.addressList = []
				this.projectSearchForm = {
					// 项目名称
					projectName: '',
					// 工程类别
					projectType: '',
					provinceCode: '',
					cityCode: '',
					countyCode: ''
				}
				this.getProjectInfo()
			},
			// 查询湖北省行政区划
			handleGetHbDivision() {
				const params = {
					parentId: '3ab7d41d88bd458da622fb21e84ea5b3',
					level: '3'
				}
				getDictFlattenList(params).then(response => {
					const { data } = response

					this.allAddressDict = data

					if (!data || data.length === 0) {
						this.divisionHbDictList = []
						return
					}
					// 创建id到节点的映射
					const nodeMap = {}
					const tree = []

					// 第一遍遍历：创建所有节点的映射
					data.forEach(item => {
						nodeMap[item.id] = {
							...item,
							children: []
						}
					})

					// 第二遍遍历：构建树形结构
					data.forEach(item => {
						const node = nodeMap[item.id]
						if (item.pId && nodeMap[item.pId]) {
							nodeMap[item.pId].children.push(node)
						} else {
							tree.push(node)
						}
					})

					// 遍历三级节点设置isLeaf为true
					tree.forEach(province => {
						if (province.children) {
							province.children.forEach(city => {
								if (city.children) {
									city.children.forEach(county => {
										county.children = null
									})
								}
							})
						}
					})

					this.divisionHbDictList = tree
					// console.log(this.divisionHbDictList)
				})
			},
			// 住所变更后切换
			xmAddressAfterChange(val) {
				this.projectSearchForm.provinceCode = val[0]
				this.projectSearchForm.cityCode = val[1]
				this.projectSearchForm.countyCode = val[2]
			},

			// 企业报告导出
			async handleExportCompanyReport() {
				if (!this.isVip && !this.isSVip) {
					this.$message.error('暂不是高级会员，请先购买会员')
					this.payVisible = true
					return
				}

				// 前置判断资质诊断权益是否耗尽
				const isValid = await this.validateMemberBenefit(ENUM_MEMBER_BENEFIT.BGDC)
				if (!isValid) {
					return
				}

				if (!this.allChartDataIsLoadingDone) {
					this.$modal.msg('分析数据正在加载中，请等待...')
					return
				}

				try {
					// 定义图表名称映射
					const chartConfigs = [
						{ ref: 'radarChart', name: '企业画像图', key: 'radarChart' },
						{ ref: 'certCountChart', name: '证件数量分析图', key: 'certCountChart' },
						{ ref: 'structureOfPersonnelChart', name: '人员结构分析图', key: 'structureOfPersonnelChart' },
						{ ref: 'certTypeChart', name: '证书类型分析图', key: 'certTypeChart' },
						{ ref: 'industryChart', name: '资质等级对比图', key: 'industryChart' },
						{ ref: 'behaviorChart', name: '企业行为记录图', key: 'behaviorChart' },
						{ ref: 'changeAnalyseChart', name: '企业变动分析图', key: 'changeAnalyseChart' }
					]

					// 收集所有图表的图片数据（异步处理）
					const chartPromises = chartConfigs.map(config => {
						return new Promise(resolve => {
							try {
								const chartRef = this.$refs[config.ref]
								if (chartRef && chartRef.$refs && chartRef.$refs.echartsRef) {
									const imageData = chartRef.$refs.echartsRef.exportAsFile(config.name + '.png')
									if (imageData) {
										resolve({
											key: config.key,
											name: config.name,
											imageData: imageData
										})
									} else {
										console.warn(`图表 ${config.name} 导出为空`)
										resolve(null)
									}
								} else {
									console.warn(`图表 ${config.name} 引用不存在`)
									resolve(null)
								}
							} catch (error) {
								console.error(`导出图表 ${config.name} 时出错:`, error)
								resolve(null)
							}
						})
					})

					// 等待所有图表处理完成
					const chartResults = await Promise.all(chartPromises)

					// 过滤掉空值，并构建请求数据
					const chartImages = {}
					chartResults.forEach(result => {
						if (result) {
							chartImages[result.key] = {
								name: result.name,
								imageData: result.imageData
							}
						}
					})

					console.log('chartImages:', chartImages)
					const formData = new FormData()

					formData.append('companyId', this.companyId)
					// 将所有图表文件添加到 FormData 中
					Object.keys(chartImages).forEach(key => {
						if (chartImages[key] && chartImages[key].imageData) {
							// 使用图表名称作为文件名，将文件对象添加到 files 字段
							formData.append('files', chartImages[key].imageData)
						}
					})

					// 执行报告生成并下载接口
					await reportGenerationDownload(exportCompnayReport(), formData, {
						defaultFileName: `企业报告-${this.companyDetail.companyName || ''}.pdf`
					})

					this.$modal.msgSuccess('报告导出成功')
				} catch (error) {
					console.error('导出报告错误:', error)
				}
			},

			// 订单创建成功回调
			handlePayOrderSuccessCallback() {
				this.payVisible = false
				this.$router.push({
					path: '/user/market/order'
				})
			},
			handleVipCancel() {
				this.payVisible = false
			}
		}
	}
</script>

<style lang="scss" scoped>
	.companyDetail-container {
		background-color: #eff6f9;
		.companyDetail-content {
			width: $main-page-width;
			margin: 0 auto;
			padding-top: 20px;
			.information-container {
				margin-bottom: 20px;
				.information-content {
					display: flex;
					justify-content: space-between;
					align-items: center;
					.basic-content {
						width: 1045px;
						// height: 247px;
						background-color: #ffffff;
						padding: 20px;
						.cjt-tabs__content {
							padding-top: 27px;
							display: flex;
							align-items: center;
							padding-left: 18px;
							img {
								margin-right: 40px;
							}
							.name {
								font-size: 20px;
								color: #333333;
								font-weight: bold;
								margin-bottom: 20px;
								.on-job {
									min-width: 106px;
									height: 28px;
									background-color: #2599fb;
									border-radius: 0px 10px 0px 10px;
									margin-left: 20px;
									font-size: 16px;
									color: #ffffff;
									text-align: center;
									line-height: 28px;
									display: inline-block;
									font-weight: normal;
								}
							}
							p {
								font-size: 16px;
								color: #333333;
								width: auto;
								display: flex;
								justify-content: space-between;
								line-height: 15px;
								margin-bottom: 15px;
							}
						}
					}
					.people-content {
						width: 335px;
						height: 290px;
						background-color: #ffffff;
						position: relative;
						.people-echarts {
							height: calc(100% - 49px);
						}
					}
				}
			}
			.table-container {
				.table-content {
					display: flex;
					justify-content: space-between;
					.table-box {
						width: 1045px;
					}
				}
				.tab-container {
					width: 100%;
					padding: 20px 20px 0px 20px;
					background: #fff;
					.pagination-container {
						padding-top: 9px;
						padding-bottom: 12px;
					}
				}
				.charts-content {
					.charts-flx {
						display: flex;
						justify-content: space-between;
						// align-items: center;
						.charts-big {
							width: 49%;
							.charts-box {
								width: 100%;
							}
						}
						.charts-box {
							position: relative;
							width: 49%;
							display: flex;
							justify-content: center;
							align-items: center;
							min-height: 200px;
							background: #eff6f9;
							margin-bottom: 20px;
							.progress-box {
								width: 49%;
								height: 130px;
							}
						}
						.charts-height {
							height: 420px;
						}
					}
				}
				.time-line-container {
					padding: 20px 0;

					.swiper-container {
						overflow: hidden;
						white-space: nowrap;

						.swiper-slide {
							width: auto;
						}
					}

					// 保留原有.time-line-item样式
					.time-line-item {
						position: relative;
						display: inline-flex;
						vertical-align: top;
						flex-direction: column;
						align-items: center;
						padding: 0px;
						flex-shrink: 0;

						&:hover {
							.line {
								background: #096dd9;

								&::before {
									width: 12px;
									height: 12px;
									background: #096dd9;
								}
							}

							.time {
								color: #096dd9;
								font-size: 18px;
							}

							.info-item {
								color: #096dd9;
								font-weight: bold;
							}
						}

						.top-info {
							display: flex;
							flex-direction: column;
							align-items: flex-start;
							align-items: center;
							margin-bottom: 10px;
							width: 300px;

							.info-item {
								font-size: 14px;
								color: #333;
								margin-bottom: 5px;
								text-align: center;
								text-overflow: ellipsis;
								white-space: nowrap;
								overflow: hidden;
								width: 100%;
							}
						}

						.line {
							width: 100%;
							height: 1px;
							background: #1890ff;
							position: relative;

							&::before {
								content: '';
								position: absolute;
								width: 10px;
								height: 10px;
								background: #1890ff;
								border-radius: 50%;
								left: 50%;
								top: 50%;
								transform: translate(-50%, -50%);
							}
						}

						.time {
							margin-top: 10px;
							font-size: 16px;
							font-weight: bold;
							color: #1890ff;
						}
					}
				}
			}

			.vip-title {
				font-size: 20px;
				color: #333333;
				font-weight: bold;
				padding: 25px 0px 0px 22px;
				position: relative;
				span {
					left: 106px;
					top: 13px;
					position: absolute;
					height: 18px;
					line-height: 18px;
					padding: 0px 7px;
				}
			}

			.cjt-tabs__item {
				&::after {
					height: 4px;
					background-color: #2671cb;
				}
				.cjt-tabs__item-text {
					font-size: 20px;
				}
			}
			.cjt-tabs__item.active {
				color: #333333;
			}
			.mt20 {
				margin-top: 20px;
			}

			.pdm20 {
				padding-bottom: 20px;
			}

			.basic-info {
				width: 90%;
				p {
					display: flex;
					justify-content: space-between;
					margin-bottom: 15px;
					span {
						flex: 1;
						&:not(:last-child) {
							margin-right: 10px;
						}
					}
					&:last-child {
						span {
							flex: none;
							width: 100%;
						}
					}
				}
			}
		}
	}
</style>
<style>
	.table-row .el-table__cell {
		border-bottom: 1px solid #bad6f0 !important;
		padding: 13px 0px;
	}
	.el-pagination {
		padding: 0px;
	}

	.search-box {
		width: 90%;
		margin: 0 auto;
	}

	.projectSearch-form {
		display: flex;
		justify-content: space-around;
	}
</style>
